export const uiLayerAppConfig = {
	tooltip: {
		delayDuration: 500,
	},
	toaster: {
		ui: {
			viewport: 'bottom-(--toast-viewport-offset) rtl:right-auto rtl:left-4',
		},
	},
	ui: {
		colors: {
			primary: 'primary',
			success: 'success',
			warning: 'warning',
			error: 'error',
			info: 'info',
			neutral: 'neutral',
		},
		icons: {
			info: 'lucide:info',
			success: 'lucide:circle-check',
			warning: 'lucide:triangle-alert',
			error: 'lucide:circle-x',
			back: 'lucide:arrow-left',
			check: 'lucide:check',
			chevronDown: 'lucide:chevron-down',
			chevronLeft: 'lucide:chevron-left',
			chevronRight: 'lucide:chevron-right',
			chevronUp: 'lucide:chevron-up',
			download: 'lucide:download',
			ellipsis: 'lucide:ellipsis',
			loader: 'lucide:loader-circle',
			enterFullscreen: 'lucide:maximize-2',
			exitFullscreen: 'lucide:minimize-2',
			plus: 'lucide:plus',
			edit: 'lucide:pencil',
			filter: 'lucide:filter',
			minus: 'lucide:minus',
			remove: 'lucide:x',
			search: 'lucide:search',
			trash: 'lucide:trash-2',
			primaryKey: 'lucide:key',
			unique: 'lucide:fingerprint',
		},
	},
};
